import initContentPermissions from 'redux/permissions/utils/initContentPermissions';
import initPrivilegesConfig from 'redux/permissions/utils/initPrivilegesConfig';

const maxPermissions = () => initContentPermissions(initPrivilegesConfig(true));

export default maxPermissions;
